import React, { useContext } from "react";
import { PaginaPesquisaProdutoContext } from "../../pagina-pesquisa-produto/PaginaPesquisaProduto";
import { AcoesHeadGridItens } from "./AcoesHeadGridItens";
import { HeadersPesquisaProdutos } from "./HeadersPesquisaProdutos";

export const TableHeadPesquisaProdutos = () => {
  const contexto = useContext(PaginaPesquisaProdutoContext)

  return (
    <>
      <thead>
        <tr>
          <th
            colSpan={contexto.colunas?.length + 2 + (contexto.chamadoParaInserirProdutoNoOrcamento && !contexto.pesquisandoApenasParaFiltroProdutosLupa ? 1 : 0)}
            id="TableHeadPesquisaProdutos_linha_x"
            style={{
              textAlign: "left",
              paddingTop: 0,
              paddingBottom: 0,
              height: "40px", // acompanha o InfoIcon fontSize="large" do GridItensPesquisaProdutos_IconeAjuda (5px de offset + 35px do ícone)
            }}
          >
            <div><AcoesHeadGridItens /></div>
          </th>
        </tr>

        <HeadersPesquisaProdutos />
      </thead>
    </>
  );
};
